import { render, staticRenderFns } from "./CbsDataRecord.vue?vue&type=template&id=b7493184&scoped=true"
import script from "./CbsDataRecord.vue?vue&type=script&lang=js"
export * from "./CbsDataRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7493184",
  null
  
)

export default component.exports